// Copyright (c) Microsoft Corporation. All rights reserved.

import { LogLevel } from "@azure/msal-browser";

export default Object.freeze({
  Auth: {
    UrlAfterRedirectKey: "wego.urlAfterRedirect"
  },
  Service: {
    timeout: 120 * 1000,
    refreshInterval: 3000
  },
  MeetingRoles: {
    Organizer: "Organizer",
    Presenter: "Presenter",
    Attendee: "Attendee",
  },
  Surfaces: {
    PreMeeting: "content",
    SidePanel: "sidePanel",
    Stage: "meetingStage",
    Unknown: "unknown",
  },
  MsalConfig: {
    auth: {
      clientId: "",
      authority: "https://login.microsoftonline.com/common",
      knownAuthorities: [],
      redirectUri: "",
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
          }
        },
        piiLoggingEnabled: false
      }
    }
  }
});
